import { data_index } from "../../dataIndex";

export const calcTotalChips = (lostCharsData: string[]) => lostCharsData.length;
export const getChallengeWordsTable = (challengeWordsData: string[]) =>
  challengeWordsData
    .map((word) => Array.from(word))
    .map((word) => word.map((char) => (char === " " ? "□" : char)))
    .map((word) => "\n" + word.join(""));
export const challengeIndex = (data_index + 1).toString().padStart(3, "0");
